module.exports = __webpack_public_path__ + "assets/img/extractionTarot.b3881fa1.png";